"use strict";
// (C) 2019-2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.attributeDescriptorName = exports.attributeDescriptorLocalId = exports.resultHeaderName = exports.isResultTotalHeader = exports.isResultMeasureHeader = exports.isResultAttributeHeader = exports.isTotalDescriptor = exports.isMeasureDescriptor = exports.isMeasureGroupDescriptor = exports.isAttributeDescriptor = void 0;
var tslib_1 = require("tslib");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
//
// Type guards
//
/**
 * Type-guard testing whether the provided object is an instance of {@link IAttributeDescriptor}.
 *
 * @public
 */
function isAttributeDescriptor(obj) {
    return !isEmpty_1.default(obj) && obj.attributeHeader !== undefined;
}
exports.isAttributeDescriptor = isAttributeDescriptor;
/**
 * Type-guard testing whether the provided object is an instance of {@link IMeasureGroupDescriptor}.
 *
 * @public
 */
function isMeasureGroupDescriptor(obj) {
    return !isEmpty_1.default(obj) && obj.measureGroupHeader !== undefined;
}
exports.isMeasureGroupDescriptor = isMeasureGroupDescriptor;
/**
 * Type-guard testing whether the provided object is an instance of {@link IMeasureDescriptor}.
 *
 * @public
 */
function isMeasureDescriptor(obj) {
    return !isEmpty_1.default(obj) && obj.measureHeaderItem !== undefined;
}
exports.isMeasureDescriptor = isMeasureDescriptor;
/**
 * Type-guard testing whether the provided object is an instance of {@link ITotalDescriptor}.
 *
 * @public
 */
function isTotalDescriptor(obj) {
    return !isEmpty_1.default(obj) && obj.totalHeaderItem !== undefined;
}
exports.isTotalDescriptor = isTotalDescriptor;
/**
 * Type-guard testing whether the provided object is an instance of {@link IResultAttributeHeader}.
 *
 * @public
 */
function isResultAttributeHeader(obj) {
    return !isEmpty_1.default(obj) && obj.attributeHeaderItem !== undefined;
}
exports.isResultAttributeHeader = isResultAttributeHeader;
/**
 * Type-guard testing whether the provided object is an instance of {@link IResultMeasureHeader}.
 *
 * @public
 */
function isResultMeasureHeader(obj) {
    return (!isEmpty_1.default(obj) &&
        obj.measureHeaderItem !== undefined &&
        obj.measureHeaderItem.order !== undefined);
}
exports.isResultMeasureHeader = isResultMeasureHeader;
/**
 * Type-guard testing whether the provided object is an instance of {@link IResultTotalHeader}.
 *
 * @public
 */
function isResultTotalHeader(obj) {
    return (!isEmpty_1.default(obj) &&
        obj.totalHeaderItem !== undefined &&
        obj.totalHeaderItem.type !== undefined);
}
exports.isResultTotalHeader = isResultTotalHeader;
//
//
//
/**
 * Returns item name contained within a result header.
 *
 * @param header - header of any type
 * @public
 */
function resultHeaderName(header) {
    if (isResultAttributeHeader(header)) {
        return header.attributeHeaderItem.name;
    }
    else if (isResultMeasureHeader(header)) {
        return header.measureHeaderItem.name;
    }
    return header.totalHeaderItem.name;
}
exports.resultHeaderName = resultHeaderName;
/**
 * Returns local identifier of attribute described in the provided attribute descriptor.
 *
 * @param descriptor - attribute descriptor, must be specified
 * @public
 */
function attributeDescriptorLocalId(descriptor) {
    return descriptor.attributeHeader.localIdentifier;
}
exports.attributeDescriptorLocalId = attributeDescriptorLocalId;
/**
 * Returns name of attribute described in the provided attribute descriptor.
 *
 * @param descriptor - attribute descriptor, must be specified
 * @public
 */
function attributeDescriptorName(descriptor) {
    return descriptor.attributeHeader.formOf.name;
}
exports.attributeDescriptorName = attributeDescriptorName;
//# sourceMappingURL=results.js.map